import styled from 'styled-components';

import { colors, radius } from '../../../../../../styles/tokens';

export const Container = styled.button`
  width: 100%;
  min-height: 140px;

  background-color: ${colors.surfaceContainerLow};
  transition: background-color 0.2s;
  border: none;

  &:hover {
    background-color: ${colors.surfaceContainer};
  }

  border-radius: ${radius.md};

  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;

  padding: 24px;

  cursor: pointer;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 48px;
    background-color: ${colors.primary};
  }
`;

export const Title = styled.span`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: ${colors.onSurfaceVariant};
  margin-bottom: 16px;
  text-align: left;
`;

export const DataRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 10px;
`;

export const Data = styled.span`
  font-size: 40px;
  font-weight: 800;
  color: ${colors.onSurface};
  text-align: left;
`;

interface GaugeTrackProps {
  percent: number;
}

export const GaugeTrack = styled.div`
  width: 100%;
  height: 8px;
  border-radius: ${radius.full};
  background-color: ${colors.surfaceContainerHigh};
  overflow: hidden;
`;

export const GaugeFill = styled.div<GaugeTrackProps>`
  height: 100%;
  width: ${({ percent }) => Math.min(100, Math.max(0, percent))}%;
  border-radius: ${radius.full};
  background-color: ${colors.primary};
  transition: width 0.3s;
`;

export const Note = styled.span`
  font-size: 11px;
  color: ${colors.onSurfaceVariant};
  margin-top: 8px;
  text-align: left;
`;
